<template>
  <div>
    <v-layout row>
      <!-- SIDEBAR -->
      <navigation
        :items="navigations.default.items"
        :drawer="true"
      ></navigation>
      <!-- TOP NAVBAR -->
      <v-toolbar dark app clipped-left class="gradient1 devant">
        <!-- LOGOS -->
        <v-toolbar-title align-center app>
          <div class="d-flex pl-2" style>
            <router-link to="/home" @click.native="emptyMultiSelectImg()" class="d-flex" >
              <v-img
                :src="require('@/assets/img/logo-ittention-img.png')"
                height="50"
                contain
                width="35"
              />
              <v-img
                :src="require('@/assets/img/logo-ittention-white.png')"
                class="mx-2"
                height="50"
                contain
                width="157"
                v-if="!xsmall"
              />
            </router-link>
          </div>
        </v-toolbar-title>
        <!-- <v-spacer/> -->
        <!-- SEARCH BAR -->
        <!-- <v-card class="card_module mx-5" id="searchBarContainer">
          <v-text-field
            id="searchBar"
            dark
            v-model="search"
            prepend-icon="fa-search"
            placeholder="SEARCH TAGS"
            style="height: 40px; box-shadow: 6px 4px 15px 2px rgba(0,0,0,0.85);"
            class="px-3 py-1"
            browser-autocomplete
          ></v-text-field>
        </v-card> -->
        <v-spacer/>
        <div id="btn-profil" class="btn-group">
          <button
            class="d-flex"
            data-toggle="dropdown"
          >
            <!-- <hexagon class="header_hex_svg"/> -->
            <!-- <v-icon class="hexagon_icon">person</v-icon> -->
            <!-- <trapez class="" v-if="!small"/> -->
            <itt-profil-btn :user="username.toUpperCase()"></itt-profil-btn>
            <!-- <p
              v-if="!small"
              class="header_trapez_text"
              style="color:white"
            >{{username.toUpperCase()}}</p> -->
          </button>
          <div class="dropdown-menu dropdown-menu-right">
            <button class="dropdown-item" type="button" @click="home()">{{$t('buttons.profile')}}</button>
            <button class="dropdown-item" type="button" @click="logout()">{{$t('buttons.logout')}}</button>
          </div>
        </div>
        <!-- </div> -->
      </v-toolbar>
      <footernav></footernav>
    </v-layout>
  </div>
</template>

<script>
import navigation from "./navigation.vue";
import footernav from "./footer.vue";
import hexagon from "../icons/hexagon.vue";
import trapez from "../icons/trapez.vue";
import ittProfilBtn from "@/components/icons/profil-btn.vue";

export default {
  name: "headernav",
  components: {
    navigation,
    footernav,
    hexagon,
    // trapez,
    ittProfilBtn
  },
  data() {
    return {
      // dropdown
      items: [
        { title: "Click Me" },
        { title: "Click Me" },
        { title: "Click Me" },
        { title: "Click Me 2" }
      ],
      fav: true,
      menu: false,
      message: false,
      hints: true,
      on: true,
      dialog: false,
      drawer: null,
      small: true,
      xsmall: false,
      search: "",
      projects: [],
      navigations: {
        default: {
          drawer: true,
          items: [
            {
              icon: "add",
              url: "",
              action: "add_media",
              color: "#77edaf"
            },
            {
              icon: "fa fa-folder-plus",
              url: "",
              action: "dialog",
              color: "#77edaf"
            },
            // {
            //   title: "RECYCLE BIN",
            //   icon: "delete",
            //   url: "",
            //   action: "",
            //   color: "#77edaf"
            // }
          ]
        }
      },
      username: this.$store.getters['authentication/getUser'].username
    };
  },
  created() {
    this.getAllProjects();
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  methods: {
    home() {
      this.$router.push("/profile");
    },
    logout() {
      this.$store.dispatch("authentication/logout");
    },
    getAllProjects() {
      this.projects = this.$store.getters["project/getProjectsAnyParent"];
    },
    changeDrawerStatus(value) {
      this.drawer = value;
    },
    changeStateDrawer() {
      this.navigations.default.drawer = !this.navigations.default.drawer;
    },
    toggleNewProject() {
      this.$store.dispatch("dialogModal/toggle");
    },
    toggleNewImg() {
      this.$store.dispatch("dialogModal/toggleModalImg");
    },
    /**Handle Screen/Window resize. Responsivity */
    handleResize() {
      let sm = window.matchMedia("(max-width: 700px)");
      let xs = window.matchMedia("(max-width: 399px)");
      if (sm.matches) {
        this.small = true;
      } else {
        this.small = false;
      }
      if (xs.matches) {
        this.xsmall = true;
      } else {
        this.xsmall = false;
      }
    },
    emptyMultiSelectImg() {
      this.$store.commit('image/emptyMultiSelectImg');
    }
  }
};
</script>

<style scoped>
#btn-profil {
  transform: translateX(-80px);
}
.dropdown-menu {
  transform: translate3d(13px, 52px, 0px) !important;
  width: 172px;
  background-color: #262626;
  box-shadow: 0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12);
}
.dropdown-menu button {
  padding: .7rem 1.5rem;
  color: white;
}
.dropdown-menu button:hover {
  background-color: #2b2b2b
}
.header_hex_icon {
  z-index: 1;
}
.header_hex_svg:hover {
  fill: #999999;
}
.header_hex_svg {
  transition: 0.4s;
  fill: #ea3719;
}
.header_trapez_text {
  z-index: 1;
  position: absolute;
  left: -56px;
}
.hexagon_svg {
  top: -5px;
  left: -125px;
}
.hexagon_icon {
  z-index: 1;
  position: absolute;
  top: 4px;
  left: -111.5px;
}
.trapez_svg {
  top: -20px;
  left: -145px;
}
.v-btn:hover .header_hex_svg {
  fill: #999999;
}
.green_fill {
  fill: #1e755d;
}
.v-btn:focus {
  outline: none;
}

#searchBarContainer {
  width: 300px;
}

@media (max-width: 700px) {
  .hexagon_svg {
    left: -5px;
  }
  .hexagon_icon {
    left: 8.5px;
  }
}
@media (max-width: 745px) {
  #searchBarContainer {
    width: 250px;
  }
}
@media (max-width: 555px) {
  #searchBarContainer {
    width: 205px;
  }
}
@media (max-width: 495px) {
  #searchBarContainer {
    width: 166px;
  }
}

</style>
